import { apiRoutes } from '@/constants/api-routes';
import { apiRequest } from './http';
import type { LearnResponse } from '@/types/api';

/**
 * Payload for `POST /learn`. Matches the server's `LearnQueryDto`.
 *
 * - `bookId` grounds the answer: the server loads the book and seeds the
 *   system prompt with its title/description before calling OpenAI.
 * - `prompt` is the user's free-text question (server enforces 1–2000
 *   chars; we trust the server to surface validation errors rather than
 *   duplicate them here).
 * - `promptId` (optional) is a stored `book_prompts` row id. When sent,
 *   the server caches the response against that row so subsequent viewers
 *   see the answer without another chat call.
 */
export interface LearnQueryPayload {
  bookId: string;
  prompt: string;
  promptId?: string;
}

export const learnService = {
  /**
   * Asks Ollie a question grounded in a book. The server rate-limits per
   * account (same guard as `/search`) so the Learn panel should disable
   * the submit button while a request is in flight.
   */
  ask(payload: LearnQueryPayload) {
    return apiRequest<LearnResponse>(apiRoutes.learn.ask, {
      method: 'POST',
      body: payload,
    });
  },
};
